import React from "react";

class Footer extends React.Component {
    render() {
        return <span>Mount Olympus Graphic UI (version 0.3) ©2021 by Chaos</span>
    }
}

export default Footer;